// src/pages/settings/Modal.tsx — wrapper de modal générique utilisé par tous les formulaires de Paramètres

export default function Modal({ title, onClose, children, wide=false, fixedHeight=false, maxWidth }:{
  title:string; onClose:()=>void; children:React.ReactNode; wide?:boolean; fixedHeight?:boolean; maxWidth?:number|string;
}) {
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:2500,
      display:"flex",alignItems:"center",justifyContent:"center",padding:fixedHeight?"16px":"24px 16px"}}>
      <div style={{background:"#fff",borderRadius:12,width:"100%",maxWidth:maxWidth ?? (wide?760:520),
        boxShadow:"0 8px 40px rgba(0,0,0,0.2)",display:"flex",flexDirection:"column",
        ...(fixedHeight?{height:"calc(100vh - 32px)"}:{maxHeight:"90vh"}),overflow:"hidden"}}>
        {/* Header */}
        <div style={{padding:"20px 24px 16px",borderBottom:"1px solid #f0f0f0",
          display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
          <h2 style={{margin:0,fontSize:16,fontFamily:"var(--ff-title)",fontWeight:900}}>{title}</h2>
          <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",fontSize:20,color:"#aaa",lineHeight:1}}>✕</button>
        </div>
        {/* Body — forms manage their own scroll/sticky layout */}
        <div style={{display:"flex",flexDirection:"column",flex:1,minHeight:0}}>
          {children}
        </div>
      </div>
    </div>
  );
}
